import { createSlice } from '@reduxjs/toolkit';
import { newPhone } from '../../reducers/account/accountThunks';
import { handleRequestThunk } from '../handleRequestThunk';
const SLICE_NAME = 'newPhone';

export const newPhoneSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        data: {},
        isLoading: false,
        error: null,
    },
    extraReducers: builder => {
        handleRequestThunk({ builder, request: newPhone });
    },
});

export const selectNewPhoneAccountData = state => state.newPhone.data;
export const selectNewPhoneAuthError = state => state.newPhone.error;
export const selectNewPhoneAuthLoading = state => state.newPhone.isLoading;

export const newPhoneReducer = newPhoneSlice.reducer;
